var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
    This file is generated with the "identicons" script.
    To update this output make changes to `scripts/svgr/identicon-icon-template.js
    */
import * as React from 'react';
import { IdenticonsCustomProperty, useColorMap, identiconComponentName } from '../common';
import { styled } from '../../styled';
export var IdenticonEnterpriseDirectory = styled(function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    var colorMap = useColorMap({
        color: color,
    });
    var fills = {
        light: "var(".concat(IdenticonsCustomProperty.light, ", ").concat(colorMap.light, ")"),
        base: "var(".concat(IdenticonsCustomProperty.base, ", ").concat(colorMap.base, ")"),
        dark: "var(".concat(IdenticonsCustomProperty.dark, ", ").concat(colorMap.dark, ")"),
    };
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M27.937 44.725l15.34-11.118c1.675-1.214 2.72-2.607 2.72-5.075 0-1.243-.48-2.442-1.344-3.344L27.073 3.214a3.956 3.956 0 00-5.672-.033L3.385 25.171c-.888.907-1.382 2.329-1.382 3.387 0 1.942 1.05 3.84 2.719 5.05l15.34 11.117a6.717 6.717 0 007.875 0z", fill: fills.light }),
        React.createElement("path", { d: "M33.463 19.309a4.31 4.31 0 00-8.617 0 4.31 4.31 0 008.617 0z", fill: fills.dark }),
        React.createElement("path", { d: "M34.629 26.73a4.678 4.678 0 00-3.31-1.372h-4.33a4.678 4.678 0 00-4.68 4.68v2.893c0 1.037.84 1.877 1.877 1.877h9.938c1.036 0 1.876-.84 1.876-1.877v-2.893c0-1.24-.493-2.432-1.371-3.309zM19.69 28.433a3.083 3.083 0 00-2.18-.903h-2.427A3.083 3.083 0 0012 30.613v1.702c0 .682.553 1.235 1.236 1.235h6.122c.682 0 1.235-.553 1.235-1.235v-1.702c0-.818-.325-1.602-.903-2.18z", fill: fills.base }),
        React.createElement("path", { d: "M19.542 22.484a3.247 3.247 0 00-3.245-3.246 3.247 3.247 0 00-3.246 3.246 3.247 3.247 0 006.491 0z", fill: fills.dark })));
}, {
    name: identiconComponentName,
})({});
